var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('bot-service-metadata-list-card',{attrs:{"header":"Platforms","hide-search":"","bot":_vm.bot,"items":_vm.platformsMetadata}})
}
var staticRenderFns = []

export { render, staticRenderFns }